<template>
	<div v-loading.fullscreen.lock="loading" class="companyDe">
		<div class="comHeader">
			<div class="center">
				<div class="left">
					<el-image :src="info.logo||require('@/static/company.png')" fit="cover" class="logo"></el-image>
					<div class="info">
						<div class="name">
							<div>
								{{info.company_name}}
							</div>
							<!-- <div class="button">
								收藏
							</div> -->
						</div>
						<div class="num">
							{{info.person_count}}
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="comCenter">
			<div class="left">
				<poDe :type='2' :details='info'></poDe>
				<div class="onRecruit">
					<div class="introduce">
						在招职位
					</div>
					<div class="onRecruitCon">
						<div v-for="(item,index) of list" :key="index" class="onRecruitConLi" @click="poDetails(item.id)">
							<div class="info">
								<div class="infoLeft">
									<img v-if="item.top==1" src='@/static/pinnedIcon.png' class="icon" />
									<img v-if="item.is_selected==1" src='@/static/winnowIcon.png' class="icon" />
									<img v-if="item.type==2" src='@/static/jobIcon.png' class="icon" />
									<div class="title">
										{{item.position_name}}
									</div>
								</div>
								<div class="pay">
									{{`${parseFloat((item.salary_min/1000).toFixed(1))}-${parseFloat((item.salary_max/1000).toFixed(1))}k`}}
								</div>
							</div>
							<div class="label">
								<div class="li">
									{{item.address.split('-')[1]}}
								</div>
								<div v-if="item.tag_name_others" class="li">
									{{item.tag_name_others.split(',')[0]}}
								</div>
								<div class="li">
									{{item.tag_name_qualifications}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<downCode class="right"></downCode>
		</div>

	</div>
</template>

<script>
	import downCode from '@/components/downCode.vue'
	import poDe from '@/components/poDe.vue'
	export default {
		name: 'companyDe',
		components: {
			downCode,
			poDe
		},
		data() {
			return {
				id:'',
				info:'',
				loading:false,
				list:[]
			}
		},
		created() {
			if (this.$route.query.id) {
				this.id=this.$route.query.id
				this.getDetail()
			}else{
				this.$router.go(-1)
			}
		},
		methods: {
			// 获取详情
			getDetail(){
				this.loading=true
				this.$axios.get('/api/client/Home/getCompanyDetails',{params:{id:this.id}}).then(res => {
					this.loading=false
					if (res.code == 200) {
						this.info=res.data
						this.getList()
					} else {
						this.$eltips(res.msg,'error')
					}
				})
			},
			// 获取职位列表
			getList(){
				let data = {
					page: 1,
					limit: 999,
					company_id:this.info.id
				}
				this.$axios.get('/api/client/Home/getPosition', {
					params: data
				}).then(res => {
					if (res.code == 200) {
						this.list = res.data.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			poDetails(id){
				this.$router.push({ name: 'positionDe',query: {id:id } });
			}
		}
	}
</script>

<style lang="scss" scoped>
	.companyDe {
		// background-color: #F1F9F8;

		.comHeader {
			width: 100%;
			background-color: #5E6174;
			padding: 38px 0;

			.center {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				width: 1200px;
				margin: 0 auto;

				.label {
					display: flex;
					align-items: center;
					margin-top: 16px;

					.li {
						padding: 6px 9px;
						background-color: rgba(245, 245, 245, 0.2);
						border-radius: 4px;
						font-size: 13px;
						color: #fff;
						margin-right: 8px;
						max-width: 80px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						&:last-child {
							margin-right: 0;
						}
					}
				}

				.left {
					display: flex;
					align-items: center;
					justify-content: space-between;
					.logo {
						width: 96px;
						height: 96px;
						border-radius: 8px;
						margin-right: 16px;
					}
					.info {
						color: #fff;
						
						.name {
							display: flex;
							align-items: center;
							font-size: 32px;
							color: #fff;
							margin-bottom: 10px;
							.button {
								width: 120px;
								line-height: 56px;
								margin-right: 16px;
								background-color: #51A190;
								border-radius: 16px;
								font-size: 16px;
								text-align: center;
								margin-left: 16px;
								cursor: pointer;
							}
						}

						.num {
							font-size: 14px;
						}
					}
				}
			}

		}

		.comCenter {
			padding: 38px 0;
			width: 1200px;
			margin: 0 auto;
			display: flex;
			align-items: flex-start;
			.left {
				width: 956px;
				margin-right: 14px;
				flex: 1;
				.onRecruit {
					border-radius: 16px;
					background-color: #FFF;
					padding: 32px 32px 17px;
					margin-top: 15px;
					.introduce {
						font-size: 22px;
						color: #151515;
						margin-bottom: 32px;
					}

					.onRecruitCon {
						display: flex;
						align-items: center;
						flex-wrap: wrap;
						.onRecruitConLi {
							border: 1px solid #EAEEED;
							padding: 18px 22px;
							box-sizing: border-box;
							border-radius: 16px;
							width: 439px;
							margin-right: 15px;
							margin-bottom: 15px;
							cursor: pointer;
							&:nth-child(2n){
								margin-right: 0;
							}
							.info {
								display: flex;
								align-items: center;
								justify-content: space-between;
								margin-bottom: 15px;
								.infoLeft{
									display: flex;
									align-items: center;
									.icon{
										width: 43px;
										height: 20px;
										margin-right: 10px;
									}
								}
								.title {
									color: #151515;
									font-size: 18px;
									width: 260px;
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
									font-weight: bold;
								}

								.pay {
									color: #51A190;
									font-size: 15px;
								}
							}
							.label {
								display: flex;
								align-items: center;

								.li {
									padding: 3px 14px;
									background-color: #F5F5F5;
									border-radius: 2px;
									color: #5E5E5E;
									font-size: 13px;
									display: block;
									margin-right: 8px;
									max-width: 80px;
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
									&:last-child {
										margin-right: 0;
									}
								}
							}
						}
					}
				}
			}
			.right{
				
			}
		}
	}
</style>